import type { OutlineSection } from './prototype2Data';

interface OutlineSectionsPanelProps {
  sections: OutlineSection[];
}

const OutlineSectionsPanel = ({ sections }: OutlineSectionsPanelProps) => (
  <div className="rounded-lg bg-[#fafafa] border border-[#e5e5e5] px-6 py-5">
    <div className="flex flex-col divide-y divide-[#e5e5e5]">
      {sections.map((section) => (
        <div key={section.title} className="py-4 first:pt-0 last:pb-0 flex flex-col gap-1">
          <span className="text-sm font-semibold text-[#0a0a0a] leading-[1.6]">{section.title}</span>
          {section.bullets.map((bullet) => (
            <span key={bullet} className="text-[13px] text-[#737373] leading-[1.6] pl-5">
              • &nbsp;{bullet}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default OutlineSectionsPanel;
